import { t } from "@/i18n-js/instance";
import {
  hasInstallmentPricing,
  isSubscriptionCanceled,
} from "@circle-react/helpers/communityMemberSubscriptionHelpers";
import {
  dateFormats,
  formattedDateTime,
} from "@circle-react/helpers/dateTimeHelpers/formattedDateTime";
import type { CommunityMemberSubscription } from "@circle-react/types/CommunityMemberSubscription";

interface RenewalDateTextProps {
  subscription: CommunityMemberSubscription;
}

export const RenewalDateText = ({ subscription }: RenewalDateTextProps) => {
  // Show ends_at date for canceled subscriptions
  if (isSubscriptionCanceled(subscription) && subscription.ends_at !== null) {
    const date = formattedDateTime({
      dateTime: new Date(subscription.ends_at),
      format: dateFormats.long_date,
    });

    return (
      <span>
        {t(`settings.paywalls_admin_dashboard.subscriptions.canceled_on`, {
          date: date,
        })}
      </span>
    );
  }

  if (subscription.cancels_on) {
    return (
      <span>
        {t(`settings.paywalls_admin_dashboard.subscriptions.canceling_on`, {
          date: formattedDateTime({
            dateTime: new Date(subscription.cancels_on),
            format: "short_month_and_date",
          }),
        })}
      </span>
    );
  }

  // Get the renewal date, preferring renews_on over next_billing_date
  const renewalDate = subscription.renews_on || subscription.next_billing_date;

  const text =
    hasInstallmentPricing(subscription) &&
    subscription.next_billing_date === subscription.ends_at
      ? t(
          "settings.paywalls_admin_dashboard.subscriptions.subscription_details_modal.all_payments_completed",
        )
      : renewalDate
        ? formattedDateTime({
            dateTime: new Date(renewalDate),
            format: dateFormats.long_date,
          })
        : " - ";
  return <span>{text}</span>;
};
